import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const ShortListEditContainer = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',

  'div.btnContainer': {
    display: 'flex',
    width: '100%',
    marginTop: '1rem',
    justifyContent: 'center',

    'div.left': {
      display: 'flex',
      flex: 1,
      width: '100%',
      justifyContent: 'flex-start',
    },

    'div.right': {
      display: 'flex',
      flex: 1,
      width: '100%',
      justifyContent: 'flex-end',
    },
  },
})